import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
import {
  getWorkInstructions,
  deleteWorkinstruction,
  softDeleteWorkinstruction,
  restoreWorkinstruction,
} from "./../../services/workinstructions";
//import { getCompanys } from "./../../services/companies";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../common/pagination";
import { paginate } from "../../utils/paginate";
import WorkInstructionTable from "../../components/workinstructionsTable.jsx";
import SearchBox from "./../../common/searchBox";
import ReusableTabNavs from "./../../common/ReusableTabNavs";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Icons imports
import newIcon from "../../assets/Icons/new.svg";
import editIcon from "../../assets/Icons/edit.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import restoreIcon from "../../assets/Icons/restore.png";
import csvIcon from "../../assets/Icons/csv.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import sharingIcon from "../../assets/Icons/sharing.svg";
import eyeIcon from "../../assets/Icons/eye.svg";

import Icon from "./../../common/icon";

const tabMenus = [
  { label: "Active", background: "#66ff8f", activeBackgroundColor: "#66ff1f" },
  { label: "Deleted", background: "#ff8282", activeBackgroundColor: "#ff8280" },
];

class WorkInstructionsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workinstructions: [],
      allWorkInstructions: [],
      checkedFields: [],
      pageSize: 10,
      count: 0,
      currentPage: 1,
      sortColumn: { path: "name", order: "asc" },
      searchQuery: "",
      errors: {},
      activeTab: 1,
    };

    this.setActiveTab = this.setActiveTab.bind(this);
  }

  // async componentDidMount() {
  //   document.title = "WorkInstructions";    
  //   const [{ data: workinstructions }, { data: companies }] = await Promise.all([
  //     getWorkInstructions(),
  //     getCompanys()
  //   ]);
    
  //   const companiesMap = companies.reduce((map, company) => {
  //     map[company._id] = company;
  //     return map;
  //   }, {});
    
  //   const enrichedWorkInstructions = workinstructions.map(wi => {
  //     const businessNoId = typeof wi.businessNo === 'object' ? wi.businessNo._id : wi.businessNo;
  //     const matchedCompany = companiesMap[businessNoId];
      
  //     return {
  //       ...wi,
  //       companyinfo: matchedCompany || null
  //     };
  //   });
    
  //   this.setState({ workinstructions: enrichedWorkInstructions });
  // }
    async componentDidMount() {
    document.title = "WorkInstructions";    
    const { data: allWorkInstructions } = await getWorkInstructions();
    this.setState({
      allWorkInstructions,
      workinstructions: this.filterWorkInstructionsByTab(
        allWorkInstructions,
        1
      ),
    });
  }

  filterWorkInstructionsByTab = (workInstructions, tabId) => {
    if (tabId === 1) {
      return workInstructions.filter((wi) => wi.status !== "deleted");
    } else if (tabId === 2) {
      return workInstructions.filter((wi) => wi.status === "deleted");
    }
    return workInstructions;
  };

  setActiveTab = (tabId) => {
    const filteredWorkInstructions = this.filterWorkInstructionsByTab(
      this.state.allWorkInstructions,
      tabId
    );
    this.setState({
      activeTab: tabId,
      workinstructions: filteredWorkInstructions,
    });
  }

  handleDelete = (workinstruction) => {
    const workinstructions = this.state.workinstructions.filter(
      (el) => el._id !== workinstruction._id
    );
    this.setState({ workinstructions });
  };
  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
    // Optional: Clear selections when changing pages
    // this.setState({ currentPage: page, checkedFields: [] });
  };

  handleSearch = (query) => {
    this.setState({ searchQuery: query, currentPage: 1 });
  };

  handleCheckboxChange = ({ target: { checked, value } }) => {
    if (checked) {
      this.setState(({ checkedFields }) => ({
        checkedFields: [...checkedFields, value],
      }));
    } else {
      this.setState(({ checkedFields }) => ({
        checkedFields: checkedFields.filter((e) => e !== value),
      }));
    }
  };

  handleToggle = () => {
    const { data: currentPageWorkInstructions } = this.getDataPagination();
    const { checkedFields } = this.state;
    
    // Get IDs of all items on current page
    const currentPageIds = currentPageWorkInstructions.map(wi => wi._id);
    
    // Check if all items on current page are selected
    const allCurrentPageSelected = currentPageIds.every(id => checkedFields.includes(id));
    
    if (allCurrentPageSelected) {
      // Unselect all items on current page
      this.setState({ 
        checkedFields: checkedFields.filter(id => !currentPageIds.includes(id))
      });
    } else {
      // Select all items on current page (add any not already selected)
      const newCheckedFields = [...checkedFields];
      currentPageIds.forEach(id => {
        if (!newCheckedFields.includes(id)) {
          newCheckedFields.push(id);
        }
      });
      this.setState({ checkedFields: newCheckedFields });
    }
  };
  sanitizeWorkinstruction = (wi, status) => {
    const { _id, actions, copyright, createdAt, __v, updatedAt, ...rest } = wi;
    return {
      ...rest,
      status,
      user: wi.user._id,
      businessNo: wi.businessNo._id,
    };
  };

  updateStateAfterAction = (component, updatedAllWorkInstructions) => {
    const filteredWorkInstructions = component.filterWorkInstructionsByTab(
      updatedAllWorkInstructions,
      component.state.activeTab
    );

    component.setState({
      allWorkInstructions: updatedAllWorkInstructions,
      workinstructions: filteredWorkInstructions,
      checkedFields: [],
    });
  };

  showResultToast = (successCount, errorCount, msgs) => {
    if (successCount > 0 && errorCount === 0) {
      toast.success(
        successCount === 1
          ? msgs.successSingle
          : msgs.successMulti(successCount)
      );
    } else if (successCount > 0 && errorCount > 0) {
      toast.warning(`${successCount} succeeded, ${errorCount} failed`);
    } else {
      toast.error(msgs.failure);
    }
  };

  handleMassSoftDelete = async (checkedWorkInstructions) => {
    if (checkedWorkInstructions.length === 0) {
      toast.warning("Please select items to delete");
      return;
    }

    let successCount = 0,
      errorCount = 0;

    try {
      for (const id of checkedWorkInstructions) {
        try {
          const wi = this.state.allWorkInstructions.find((w) => w._id === id);
          const sanitized = this.sanitizeWorkinstruction(wi, "deleted");
          await softDeleteWorkinstruction(id, sanitized);
          successCount++;
        } catch (ex) {
          errorCount++;
          console.error("Failed to soft delete:", id, ex);
        }
      }

      const updatedAll = this.state.allWorkInstructions.map((wi) =>
        checkedWorkInstructions.includes(wi._id)
          ? { ...wi, status: "deleted" }
          : wi
      );

      this.updateStateAfterAction(this, updatedAll);

      this.showResultToast(successCount, errorCount, {
        successSingle: "Work instruction moved to deleted!",
        successMulti: (n) => `${n} work instructions moved to deleted!`,
        failure: "Failed to delete work instructions",
      });
    } catch (ex) {
      toast.error("An error occurred during deletion");
    }
  };

  handleMassPermanentDelete = async (checkedWorkInstructions) => {
    if (checkedWorkInstructions.length === 0) {
      toast.warning("Please select items to permanently delete");
      return;
    }

    let successCount = 0,
      errorCount = 0;

    try {
      for (const id of checkedWorkInstructions) {
        try {
          await deleteWorkinstruction(id);
          successCount++;
        } catch (ex) {
          errorCount++;
          console.error("Failed to permanently delete:", id, ex);
        }
      }

      const updatedAll = this.state.allWorkInstructions.filter(
        (wi) => !checkedWorkInstructions.includes(wi._id)
      );

      this.updateStateAfterAction(this, updatedAll);

      this.showResultToast(successCount, errorCount, {
        successSingle: "Work instruction permanently deleted!",
        successMulti: (n) => `${n} work instructions permanently deleted!`,
        failure: "Failed to permanently delete work instructions",
      });
    } catch (ex) {
      toast.error("An error occurred during permanent deletion");
    }
  };

  handleMassRestore = async (checkedWorkInstructions) => {
    if (checkedWorkInstructions.length === 0) {
      toast.warning("Please select items to restore");
      return;
    }

    let successCount = 0,
      errorCount = 0;

    try {
      for (const id of checkedWorkInstructions) {
        try {
          const wi = this.state.allWorkInstructions.find((w) => w._id === id);
          const sanitized = this.sanitizeWorkinstruction(wi, "active");
          await restoreWorkinstruction(id, sanitized);
          successCount++;
        } catch (ex) {
          errorCount++;
          console.error("Failed to restore:", id, ex);
        }
      }

      const updatedAll = this.state.allWorkInstructions.map((wi) =>
        checkedWorkInstructions.includes(wi._id)
          ? { ...wi, status: "active" }
          : wi
      );

      this.updateStateAfterAction(this, updatedAll);

      this.showResultToast(successCount, errorCount, {
        successSingle: "Work instruction restored successfully!",
        successMulti: (n) => `${n} work instructions restored successfully!`,
        failure: "Failed to restore work instructions",
      });
    } catch (ex) {
      toast.error("An error occurred during restoration");
    }
  };

  getDataPagination = () => {
    const {
      pageSize,
      currentPage,
      workinstructions,
      sortColumn,
      searchQuery,
    } = this.state;
    
    let filtered = workinstructions;
    if (searchQuery) {
      filtered = workinstructions.filter(
        (workinstruction) =>
          workinstruction.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          workinstruction.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          workinstruction.department?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const paginatedData = paginate(sorted, currentPage, pageSize);
    return { data: paginatedData };
  };

  render() {
    const { length: count } = this.state.workinstructions;
    const {
      pageSize,
      currentPage,
      sortColumn,
      searchQuery,
      activeTab,
      checkedFields,
    } = this.state;

    const { data: workInstructions } = this.getDataPagination();

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/workinstructions/workinstructions">Work Instructions</Link>
          </li>
        </ol>
        <h1 className="page-header">Work Instructions</h1>
        <Panel>
          <PanelHeader>Work Instructions Management</PanelHeader>

          <React.Fragment>
            <ToastContainer />
            <div className="toolbar" style={toolbarStyles}>
              {activeTab === 2 ? (
                <>
                  <Icon
                    handleClick={() => this.handleMassRestore(checkedFields)}
                    title="Restore selected items"
                    btnStyle={btnStyles}
                    iconStyle={iconStyles}
                    icon={restoreIcon}
                  />
                  <Icon
                    handleClick={() =>
                      this.handleMassPermanentDelete(checkedFields)
                    }
                    title="Permanently delete selected item"
                    btnStyle={btnStyles}
                    iconStyle={iconStyles}
                    icon={trashIcon}
                  />
                </>
              ) : (
                <>
              <Icon
                to={{
                  pathname: "/workinstructions/workinstructions/new",
                  state: {
                    kan: "",
                    prevPage: "",
                  },
                }}
                title="Add work instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={newIcon}
              />

              <Icon
                to={{
                  pathname: this.state.checkedFields.length > 0
                    ? `/workinstructions/${this.state.checkedFields[0]}`
                    : "/workinstructions/",
                  state: {
                    prevPage: "workinstructions",
                  },
                }}
                title="Edit work instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={editIcon}
              />

              <Icon
                handleClick={() =>
                  this.handleMassSoftDelete(this.state.checkedFields)
                }
                title="Delete work instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={trashIcon}
              />

              <Icon
                to={{
                  pathname: this.state.checkedFields.length > 0
                    ? `/workinstructions/workinstructions/board/${this.state.checkedFields[0]}`
                    : "/workinstructions/workinstructions/",
                  state: {
                    prevPage: "workinstructions",
                  },
                }}
                title="View board"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={eyeIcon}
              />

              <Icon
                to="/workinstructions/"
                title="excel"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={xlsIcon}
              />

              <Icon
                to="/workinstructions/"
                title="csv"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={csvIcon}
              />

              <Icon
                to="/workinstructions/"
                title="pdf"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={pdfIcon}
              />

              <Icon
                to="/workinstructions/"
                title="share"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={sharingIcon}
              />
               </>
              )}
            </div>
            <div style={{ padding: "10px" }}>
              <ReusableTabNavs
                setActiveTab={this.setActiveTab}
                activeTab={activeTab}
                navprops={tabMenus}
              />
            </div>
            <div className="table-responsive">
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <p className="page-header float-xl-left" style={{ marginBottom: 5, marginLeft: 20, marginTop: 5 }}>
                {count} entries
              </p>

              <WorkInstructionTable
                workInstructions={workInstructions}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
                sortColumn={sortColumn}
                handleCheckboxChange={this.handleCheckboxChange}
                toggle={this.handleToggle}
                checkedFields={this.state.checkedFields}
              />
            </div>
          </React.Fragment>

          <hr className="m-0" />
          <PanelBody>
            <div className="d-flex align-items-center justify-content-center">
              <Pagination
                itemsCount={count}
                pageSize={pageSize}
                onPageChange={this.handlePageChange}
                currentPage={currentPage}
              />
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}
const toolbarStyles = {
  background: "#c8e9f3",
  padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
  width: "25px",
  height: "25px",
  marginRight: "0rem",
};

export default WorkInstructionsTable;
